export enum reportsPaths {
  specific = '/reports/specific/:reportType',
  presets = '/reports/presets',
  root = '/reports',
  specificPresets = '/reports/specific/:reportType/presets',
}
